import rect from '#utilities/js/ea/rect.js'
import { handled } from '#utilities/js/ea/submitter.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import mouseDown from '@mailobj-browser/front/js/events/types/mouseDown.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as lightbox from '../lightbox.js'
import * as seamless from '../seamless.js'

const closingKeys = array(['Escape', 'Tab'])

let current = null

export const { close, events, focus, isOpen, open, opener } = seamless
export const { stash, unstash } = lightbox

export const list = element => {
  if (current && current.contains(element)) {
    return current
  }
}

const onTapUp = object(tapUp, {
  capture,
  passive,
  task: async (list, event) => {
    const { target } = event
    const submitter = target?.closest('[type="submit"]')

    if (submitter) {
      await handled(submitter)
      close()

      return
    }

    if (list === target || !list.contains(target)) {
      stopImmediatePropagation(event)
      close()
    }
  }
})

export const onKeyDown = object(listener, {
  type: keyDown,
  capture,
  async task (element, event) {
    const { keys } = this
    const { key, target } = event

    if (closingKeys.includes(key)) {
      const focusable = opener(current)

      if (lightbox.hasModal()) {
        lightbox.preventClose()
      }

      preventDefault(event)
      stopImmediatePropagation(event)
      close()
      focusable.focus()

      return
    }

    const { [key]: pick } = keys

    if (pick) {
      preventDefault(event)
      stopImmediatePropagation(event)

      if (element !== current) {
        const li = one('li', current)

        focus(li)
        this.listen(current)
        this.forget(element)

        return
      }

      const li = target.closest('li')
      const next = await pick(element, li, event)

      if (next) {
        focus(next)
      }

      return
    }

    if (key === 'Enter' && element === current) {
      const { ownerDocument } = target
      const { defaultView } = ownerDocument
      const { MouseEvent } = defaultView

      target.dispatchEvent(new MouseEvent(mouseDown, {
        buttons: 1
      }))
    }
  }
})

export const display = async (content, opener, event = null) => {
  const { width } = rect(opener)

  // content.style.minWidth = `${width}px`
  content.style.setProperty('--ea_utilities_calculated_width', `${width}px`)
  await seamless.display(content, opener, event)
  onTapUp.listen(content)
  current = content

  return content
}

